// Route: /library/folders/$folderId — страница папки Библиотеки.
//
// Канонический роут с 2026-08-14. До этого деталь жила под `/collections/$setId`,
// то есть СПИСОК сущности был под одним префиксом (`/library`), а её карточка —
// под другим: разные разделы для одного и того же.
//
// Два legacy-адреса редиректят сюда и останутся жить: `/collections/$setId`
// (ссылки в переписке с репетитором — deep-link'и лежат в карточках сообщений
// в БД) и `/materials/sets/$setId`. Вся логика — в CollectionDetail.

import { DETAIL_WITH_RAIL } from "@studyhub/ui";
import { Skeleton } from "@studyhub/ui/components/skeleton";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { CollectionDetail } from "@/components/library/collection-detail";

export const Route = createFileRoute("/library/folders/$folderId")({
	component: CollectionDetailPage,
	pendingComponent: CollectionDetailPending,
});

function CollectionDetailPage(): React.ReactElement {
	const { folderId } = useParams({ from: "/library/folders/$folderId" });
	return <CollectionDetail setId={folderId} />;
}

/** Layout-skeleton страницы папки — повторяет структуру реального роута:
 *  тесный back-link + шапка + двухколоночный workspace (контент + sticky-рельс). */
function CollectionDetailPending(): React.ReactElement {
	return (
		<div className="px-4 py-6 lg:px-6">
			<Skeleton className="mb-3 h-8 w-28 rounded-[var(--radius-lg)]" />
			<div className="flex flex-col gap-5">
				<Skeleton className="h-28 w-full rounded-[var(--radius-panel)]" />
				<div className={DETAIL_WITH_RAIL}>
					<div className="flex flex-col gap-4">
						<Skeleton className="h-10 w-full rounded-[var(--radius-lg)]" />
						<div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
							{Array.from({ length: 4 }, (_, i) => i).map((i) => (
								<Skeleton key={i} className="h-[72px] w-full rounded-[var(--radius-card)]" />
							))}
						</div>
					</div>
					<Skeleton className="hidden h-72 w-full rounded-[var(--radius-panel)] lg:block" />
				</div>
			</div>
		</div>
	);
}
